import {
  useListMyBetsV3Query,
  BetListOutputV3FieldsFragment,
} from '../../__generated__/graphqlApi';
import { useMemo } from 'react';
import { WatchQueryFetchPolicy } from '@apollo/client';

const useListMyBetsOfMatchOperation = (params: {
  matchId: string | undefined;
  fetchPolicy?: WatchQueryFetchPolicy;
  pollInterval?: number;
}) => {
  const { matchId, fetchPolicy = 'cache-and-network', pollInterval } = params;
  const { data, refetch, startPolling, stopPolling, loading } =
    useListMyBetsV3Query({
      fetchPolicy,
      variables: { matchId: matchId || '', marketId: null },
      pollInterval,
      skip: matchId == null,
    });

  return {
    refetch,
    loading,
    polling: {
      startPolling,
      stopPolling,
    },
    output: useMemo<BetListOutputV3FieldsFragment>(() => {
      const result = data?.listMyBetsV3;
      return {
        betGroups: result?.betGroups ?? [],
        totalBonusReturns: result?.totalBonusReturns ?? null,
        totalBonusBets: result?.totalBonusBets ?? null,
        bonusProfit: result?.bonusProfit ?? null,
        totalCashReturns: result?.totalCashReturns ?? null,
        totalCashBets: result?.totalCashBets ?? null,
        cashProfit: result?.cashProfit ?? null,
        totalBetCount: result?.totalBetCount ?? null,
        totalCorrectBetCount: result?.totalCorrectBetCount ?? null,
        totalUnconfirmedBetCount: result?.totalUnconfirmedBetCount ?? null,
      };
    }, [data?.listMyBetsV3]),
  };
};

export default useListMyBetsOfMatchOperation;
